import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Card, CardBody, CardHeader } from 'reactstrap';
import SearchInput from '../../common/search/searchInput';
import Icon from '../../common/containers/icon';
import entityComposition from '../../common/classes/entityComposition';
const OrganizationsFilters = _ref => {
  let filters = _ref.filters,
    organizationActions = _ref.organizationActions,
    indexQuery = _ref.indexQuery,
    initialIndexQuery = _ref.initialIndexQuery;
  const handleClear = () => {
    organizationActions.serverFilter(initialIndexQuery.filters, initialIndexQuery);
  };
  const handleFilter = value => {
    const newFilters = _objectSpread(_objectSpread({}, indexQuery.filters), {}, {
      text: value
    });
    organizationActions.serverFilter(newFilters, indexQuery);
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 8
  }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    size: "sm",
    onClick: handleClear,
    className: "float-md-right t-oc-filter-clear"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "times-circle",
    weight: "far"
  }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
    type: "text",
    text: filters.text,
    onChange: handleFilter,
    onClear: handleClear
  })));
};
OrganizationsFilters.propTypes = {
  filters: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  indexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  initialIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  organizationActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { OrganizationsFilters as TestOrganizationsFilters };
export default entityComposition(OrganizationsFilters, [], {
  filters: state => state.organization.indexQuery.filters,
  initialIndexQuery: state => state.organization.initialIndexQuery,
  indexQuery: state => state.organization.indexQuery
}, ['organization']);